import { useClientContext } from '@/context/ClientContext';
import { ClientContact } from '@/entities/clientContact';
import CustomInputPhoneMask from '@/utils/customInputPhoneMask';
import { SquarePenIcon, SquareUserRound, Trash2Icon } from 'lucide-react';
import DeleteDialog from './DeleteClientDialog';
import React from 'react';
interface ContactFormData{
    id: number,
    name: string,
    clientId: number,
    phone: string,
    email: string,
    cellPhone: string,
    function: string
}

type ContactCardProps = {
    contact: ContactFormData;
    index: number;
    onDelete: (id:number) => void;
    onEdit: (contact:ClientContact) => void;
};

// eslint-disable-next-line
const CardContact: React.FC<ContactCardProps> = ({contact, onDelete, onEdit, index}) => {

  const {openContact, setOpenContact, setEditContact, setData2Edit, setDeleteContact, setDeleteClient, indexEdit, setIndexEdit} = useClientContext();

  return (
    <div className="w-[95%] pb-2 ml-4 relative before:absolute before:ml-8 before:h-full before:w-0.5 before:bg-indigo-100">
      <div className="relative">
        <div className="md:flex items-center mb-1 px-4">
          <div className="flex items-center space-x-4">
            <div className="flex bg-indigo-400 items-center justify-center w-8 h-8 rounded-full md:order-1">
              <SquareUserRound size={14} className='text-white bg-indigo-400'/>
            </div>
          </div>
          <div className='w-full'>
            <div className="flex text-slate-500 items-center ml-4 gap-2 pt-2 ">
              <div>
                <div>
                  {/* eslint-disable-next-line */}
                  <span className="text-slate-700">{`Nome: ${contact.name}`}</span>
                </div>
                <div>
                  {/* eslint-disable-next-line */}
                  <span className="text-slate-700">{`Email: ${contact.email}`}</span>
                </div>
                <div>
                  {/* eslint-disable-next-line */}
                  <span className="text-slate-700">{`Telefone: ${CustomInputPhoneMask.format(contact.phone)}`}</span>
                </div>
                <div>
                  {/* eslint-disable-next-line */}
                  <span className="text-slate-700">{`Celular: ${CustomInputPhoneMask.format(contact.cellPhone)}`}</span>
                </div>
                <div>
                  {/* eslint-disable-next-line */}
                  <span className="text-slate-700">{`Função: ${contact.function}`}</span>
                </div>
             
              </div>
              {/* eslint-disable-next-line */}
              <button title='Excluir' onClick={()=>{
                {/* eslint-disable-next-line */}
                setDeleteClient(false);
              }}>
                {/* eslint-disable-next-line */}
                <DeleteDialog handleDelete={() => {onDelete(contact.id);}}/>
              </button> 
              <button title='Editar' onClick={()=>{
                setData2Edit(contact);
                // onEdit(contact);
                setIndexEdit(true);
                setOpenContact(!openContact);
                setEditContact(true);
              }}>
                <SquarePenIcon size={26} className='bg-indigo-50 hover:bg-indigo-200 rounded-md p-1'  />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardContact;
